import React from 'react';

import AssistantMessage from './assistant_message';
import UserMessage from './user_message';

import type { Message } from './types';

interface Props {
  message: Message;
  showAdminDetails: boolean;
  showStopSpeaking: boolean;
  onStopSpeaking: () => void;
}

export default function MessageItem({ message, showAdminDetails, showStopSpeaking, onStopSpeaking }: Props) {
  if (message.role === 'user') {
    return <UserMessage message={message} />;
  }

  return (
    <AssistantMessage
      message={message}
      showAdminDetails={showAdminDetails}
      showStopSpeaking={showStopSpeaking}
      onStopSpeaking={onStopSpeaking}
    />
  );
}
